import { createFileRoute } from '@tanstack/react-router';
import { ControlLibraryItemDetailsEdit } from './ControlLibraryItemDetailsEdit';

export const Route = createFileRoute('/admin-console/platform-content/obligations/controls-library/$id/details')({
    component: () => <ControlLibraryItemDetailsEdit />,
});
